import { ICity } from "@/shared/types/city";
import { getFromLocalStorage, saveToLocalStorage } from "./functions";
function saveCityLocalStorage(city: ICity | undefined) {
    saveToLocalStorage('city', city);
}

function getCityLocalStorage(): ICity | null {
    const city = getFromLocalStorage('city');
    return city;
}

export {
    saveCityLocalStorage,
    getCityLocalStorage,
}